module.exports = __webpack_public_path__ + "static/img/fingerpost_coupon_2.c9ca280.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_coupon_2.jpg
// module id = GDfJ
// module chunks = 0